import { Chip } from "@mui/joy";
import PersonRoundedIcon from "@mui/icons-material/PersonRounded";

// Небольшой бейдж «кто добавил доп». Возвращает null, если автор неизвестен
// (старые допы до фичи). Допы, добавленные чертёжником, подсвечиваются —
// чтобы менеджеры сразу видели, что доп указал чертёжник.
export default function AddedByChip({ item, size = "sm" }) {
  const name = item?.added_by_name;
  if (!name) return null;
  const role = item?.added_by_role;
  const roleLabel = item?.added_by_role_display
    || (role === "draftsman" ? "Чертёжник" : role === "manager" ? "Менеджер" : "");
  const color = role === "draftsman" ? "warning" : "neutral";
  return (
    <Chip
      size={size}
      variant="soft"
      color={color}
      startDecorator={<PersonRoundedIcon sx={{ fontSize: 14 }} />}
      sx={{ fontSize: "0.65rem", fontWeight: 600 }}
    >
      {roleLabel ? `${roleLabel}: ${name}` : name}
    </Chip>
  );
}